module.exports = __webpack_public_path__ + "img/horizontal_3_3_6000.37b59c8f.png";